import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { NgxSpinnerService } from 'ngx-spinner';
import { MeliServices } from 'src/app/services/meli.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';


@Component({
    selector: 'app-meli-new-wizard',
    templateUrl: './meli-new-wizard.component.html',
    styleUrls: ['./meli-new-wizard.component.scss'],
    standalone: false
})
export class MeliNewWizardComponent implements OnInit {
  produtosCatalogo: Object[] = [];
  showQuestion: boolean;

  constructor(private formBuilder:UntypedFormBuilder,
    private meliservices:MeliServices,
    private spinner:NgxSpinnerService,
    public us:UserAuthenticationServices ) { }

  searchMode  = true;
  codeCompany = 0;
  codeContract = 2;
  codeProduct = 32177;
  codeMeli =1;
  firstFormGroup:UntypedFormGroup;
  showCatalogoProducts = false;
  @Input('data') data:any;
  $$REFERENCES;
  formViewColumns;
  parentRow;
  entityName;
  entityDesc;
  row;
  filter;
  userConfig;
  tableInformation;
  canConfig;
  oldMeli = true;
  actionList;
  evento:string;
  formGroup:UntypedFormGroup;
  dataMultiTableConfig;
  @Input() forceParentRow: string;
  @Output() saving:EventEmitter<{changing:boolean, keepOpen:boolean}> = new EventEmitter();

  salvandoPrincipal(evento){
      this.saving.emit(evento);
  }


  ngOnInit(): void {
      
      this.formGroup = this.formBuilder.group({});

      this.firstFormGroup =  this.formBuilder.group({
        searchCatalogo: ''
      });

      
      this.evento = this.data.evento;
      this.formGroup = this.data.formGroup;
      this.actionList =this.data.actionList;
      this.forceParentRow = this.data.forceParentRow;
      this.$$REFERENCES = this.data.$$REFERENCES;
      this.parentRow = this.data.parentRow;
      this.formViewColumns = this.data.formViewColumns;
      this.entityName = this.data.entityName;
      this.row = this.data.row;
      this.filter = this.data.filter;
      this.userConfig = this.data.userConfig;
      this.tableInformation = this.data.tableInformation;
      this.canConfig = this.data.canConfig
      this.dataMultiTableConfig= this.data.dataMultiTableConfig;
      
      if ( this.userConfig['genericModeMeli']){
          this.oldMeli = !this.userConfig['genericModeMeli'];
      }

      if ( this.evento =='editando'){
        this.searchMode = false;  
      }
      
      /*this.data = {
          parentRow:{
              linha:{
                  CODEPRODUCT:this.codeProduct,
                  CODECONTRACT:this.codeContract,
              }
          },
          row:{
              CODEMELI:1,
              CODECOMPANY: this.codeCompany
          },
          evento:'inserindo',
          formGroup: this.formGroup
      }*/
  }

  buscaProduto(){
      let desc = this.firstFormGroup.get('searchCatalogo').value;

      let isIdentifier = false;
      try{
        if ( Number.isNaN(Number(desc))){
          isIdentifier = false;
        }else{
          isIdentifier = true;
        }
        
      }catch(Exception){
        throw(Exception)
      }
      if ( this.codeCompany == 0 ){
          throw new Error('Selecione uma empresa para buscar o produto no catálogo');
      }

      
      this.meliservices.getProdutoCatalogo(desc,this.codeCompany,isIdentifier ?desc : null).then(prods=>{
        if (prods['results']){
          this.showCatalogoProducts = true;
          this.produtosCatalogo = prods['results']
        }
        //this.spinner.hide();
      }).catch((error)=>{
          //this.spinner.hide();
          setTimeout(function() { throw  error; });
      })
  }

  novoAnuncio(){
    this.searchMode  = false;
    
  }

  getSelecionado(data){
      // Disponibiliza o produto completo do catálogo para o formulário de edição
      // (meli-edit-form lê data.catalogProduct e preenche todos os campos possíveis)
      this.data.catalogProduct = data;
      this.searchMode  = false;
      setTimeout(()=>{
        this.formGroup.get('TITLE')?.setValue(data['name']);
        this.formGroup.get('CATALOG_PRODUCT_ID')?.setValue(data['id']);
      },100);

  }
}
